import { MapPin } from "lucide-react";
import { ZONE_IMAGE } from "../data/site";
import { FadeUp, SectionHead } from "./motion";
import { useLang } from "../context/LangContext";

export const Zone = () => {
  const { S } = useLang();
  const Z = S.zone;
  return (
    <section id="zone" data-testid="zone-section" className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <SectionHead
              eyebrow={Z.eyebrow}
              title={Z.title}
              subtitle={Z.subtitle}
            />
            <FadeUp delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-2.5" data-testid="zone-cities">
                {Z.cities.map((city) => (
                  <span
                    key={city}
                    className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors duration-300 hover:border-sky-400 hover:text-sky-700"
                  >
                    <MapPin className="w-3.5 h-3.5 text-sky-600" />
                    {city}
                  </span>
                ))}
              </div>
            </FadeUp>
            <FadeUp delay={0.28}>
              <p className="mt-8 font-tech text-xs uppercase tracking-[0.22em] text-slate-400">
                46.760° N — 7.175° E · Villarsel-sur-Marly
              </p>
            </FadeUp>
          </div>

          <FadeUp delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl border border-sky-200" aria-hidden="true" />
              <img
                src={ZONE_IMAGE}
                alt={Z.imageAlt}
                loading="lazy"
                className="relative w-full aspect-[4/3] object-cover rounded-3xl shadow-2xl shadow-slate-900/15"
              />
              <div className="absolute -bottom-6 -left-4 sm:-left-8 rounded-2xl bg-[#0A182E] px-6 py-5 shadow-2xl">
                <p className="font-display text-lg font-bold text-white">{Z.badge1}</p>
                <p className="text-xs text-slate-300 mt-1">{Z.badge2}</p>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
